import type { BeneficiaryDesignationsFormShape } from '@/modules/beneficiaryDesignations/BeneficiaryDesignationsForm.types';
import type { DispositiveProvisionsFormShape } from '@/modules/dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsForm.types';
import type { DispositiveProvisionsFormV2Shape } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/DispositiveProvisionsFormV2.types';
import { PathsOf } from '@/types/subform';

export enum DispositionScheme {
  NONE = 'NONE', //  there are explicitly no dispositions
  UPON_FIRST_DEATH = 'UPON_FIRST_DEATH', // the dispositions occur upon first death
  UPON_SECOND_DEATH = 'UPON_SECOND_DEATH', // the dispositions occur upon second
}

// -----------------------------
// Shared types used across both legacy and V2 DP forms
// -----------------------------

// Intersection of every DP-shape so that recipient subcomponents (e.g.
// AssetSelectorDropdown) can be reused across versions. The beneficiary
// designations form reuses these subcomponents too — the recipient row
// inside BDG matches the DP recipient row, including its asset distribution
// UI — so it's part of the combined shape as well.
export type CombinedFormShape = DispositiveProvisionsFormShape &
  DispositiveProvisionsFormV2Shape &
  BeneficiaryDesignationsFormShape;

// Helper for type-safe React-Hook-Form field paths that work with either schema.
export type CombinedPaths = PathsOf<CombinedFormShape>;
